module.exports = __webpack_public_path__ + "static/img/アセット 28@2x.e96f26f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 28@2x.png
// module id = 2Sl6
// module chunks = 1